import AbstractNotification from './AbstractNotification';
import React from 'react';
import {INotificationProps} from '../../@interfaces/components/Notifications/INotificationProps';

export default class UnknownNotification<P extends INotificationProps = INotificationProps> extends AbstractNotification<P> {
    protected renderAvatar(): React.ReactNode {
        return this.renderIconAvatar('fas fa-question', 'secondary');
    }
}
